<template>
  <div class="lv-data-diff-card">
    <div class="lv-data-diff-card__card-list">
      <LvTextCard outline :cardHeader="beforeTitle" class="lv-data-diff-card__card">
        <template #content>
          <div class="lv-text-card__content lv-data-diff-card__content">
            <p>{{ _beforeText }}</p>
          </div>
        </template>
      </LvTextCard>
      <LvTextCard outline :cardHeader="afterTitle" class="lv-data-diff-card__card">
        <template #content>
          <div class="lv-text-card__content lv-data-diff-card__content">
            <p>{{ _afterText }}</p>
          </div>
        </template>
      </LvTextCard>
    </div>
    <LvTextCard leadingIcon="icon-edit" :cardHeader="diffTitle" class="mt-20">
      <template #content>
        <div class="lv-text-card__content lv-data-diff-card__content">
          <p>
            <span
              v-for="(part, partIndex) in _diffText"
              :key="partIndex"
              :class="{ delete: part.removed, correct: part.added }"
              >{{ part.value }}</span
            >
          </p>
        </div>
      </template>
    </LvTextCard>
  </div>
</template>

<script>
import { diffJson } from 'diff';

export default {
  props: {
    beforeData: {
      type: Object,
      default: null,
    },
    afterData: {
      type: Object,
      default: null,
    },
    beforeTitle: {
      type: String,
      default: '',
    },
    afterTitle: {
      type: String,
      default: '',
    },
    diffTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    _beforeText() {
      return this.beforeData ? JSON.stringify(this.beforeData, null, 2) : '';
    },
    _afterText() {
      return this.afterData ? JSON.stringify(this.afterData, null, 2) : '';
    },
    _diffText() {
      return diffJson(this.beforeData || {}, this.afterData || {});
    },
  },
};
</script>

<style lang="scss" scoped>
.lv-data-diff-card__card-list {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
}
.lv-data-diff-card__card {
  flex: 1 1 0;
  min-width: 0;
}
.lv-data-diff-card__content p {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
